import { useState } from "react";
import { toast } from "sonner";
import { FileText, Loader2 } from "lucide-react";
import api, { downloadFile } from "@/lib/api";
import { usePaywall } from "@/context/PaywallContext";

export const BrandGuideButton = ({ jobId, filename }) => {
  const [busy, setBusy] = useState(false);
  const paywall = usePaywall();

  const onClick = async () => {
    setBusy(true);
    try {
      const stem = filename.replace(/\.[^.]+$/, "");
      await downloadFile(`/api/jobs/${jobId}/brand-guide`, `${stem}_brand_guidelines.pdf`);
      const { data } = await api.get(`/jobs/${jobId}/brand-fonts`);
      const f = data.fonts;
      toast.success(f ? `Brand guide ready · fonts: ${f.heading.family} + ${f.body.family}` : "Brand guide ready");
    } catch (err) {
      if (err.status === 402) return paywall.open({ job_id: jobId, name: filename });
      toast.error(err.message || "Brand guide failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid="download-brand-guide-btn"
      className="inline-flex items-center gap-2 rounded-none border border-[#0A0A0B] bg-white hover:bg-[#0A0A0B] hover:text-white text-[#0A0A0B] text-xs uppercase tracking-[0.2em] font-bold h-12 px-6 transition-colors duration-200 cursor-pointer disabled:opacity-60 disabled:cursor-wait"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
      {busy ? "Matching fonts…" : "Brand guide (.pdf)"}
    </button>
  );
};
